// ./src/lib/RatingRepo.js

import Api from './PlayerApi';

// here will be some transformation logic
const medals = ['gold', 'silver', 'bronze'];

const prepareRatingList = (rating, roundsQty) => {
  // find max rounds
  const roundNumbers = rating
    .map(r => r.score)
    .map((scores) => {
      const nums = Object.keys(scores).map(s => /^round(\d+)$/.exec(s)[1]);
      return Math.max(...nums);
    });

  const maxRound = Math.max(...roundNumbers, roundsQty);

  // find max scores
  // const totalScores = rating
  //   .map(r => Object.keys(r.score).reduce((sum, key) => sum + r.score[key], 0));

  // const maxScores = Array.from(new Set(totalScores))
  //   .sort()
  //   .reverse()
  //   .slice(0, 3)
  //   .reduce((result, item, idx) => ({ ...result, [item]: medals[idx] }), {});

  return rating
    .map((r) => {
      const { team, score: scoreRaw } = r;

      const score = new Array(maxRound).fill(0)
        .map((_, idx) => scoreRaw[`round${idx + 1}`] || _);

      const total = score.reduce((sum, s) => sum + s, 0);
      // const medal = ''; // maxScores[total] || '';

      return {
        team,
        medal: '',
        total,
        score,
      };
    })
    .sort((a, b) => {
      if (a.total > b.total) return -1;
      if (a.total < b.total) return 1;

      return 0;
    })
    .map((item, idx) => ({
      ...item,
      pos: idx + 1,
      medal: medals[idx] || '',
    }));
};

const combineRatings = (general, lol, maxRounds) => {
  const teams = general.concat(lol).map(x => x.team)
    .reduce((result, team) => result.add(team), new Set());

  return [...teams]
    .map((team) => {
      const gInfo = general.find(x => x.team === team);
      const gScore = (gInfo && gInfo.score) || {};
      const lInfo = lol.find(x => x.team === team);
      const lScore = (lInfo && lInfo.score) || {};

      const score = new Array(maxRounds).fill(0)
        .map((_, idx) => gScore[`round${idx + 1}`] || _);

      const totalGeneral = score.reduce((sum, x) => sum + x, 0);
      const totalLol = Object.keys(lScore).reduce((sum, key) => sum + lScore[key], 0);

      return {
        team,
        score,
        totalGeneral,
        totalLol,
        total: totalGeneral + totalLol,
      };
    })
    .sort((a, b) => {
      if (a.total > b.total) return -1;
      if (a.total < b.total) return 1;

      return 0;
    })
    .map((item, idx) => ({
      ...item,
      pos: idx + 1,
      medal: medals[idx],
    }));
};

export default {
  getRatingTable: (selector, maxRounds = 6) => Api
    .getRating(selector)
    .then(([generalRating, lolRating]) => {
      const general = prepareRatingList(generalRating, maxRounds);
      const lol = prepareRatingList(lolRating, maxRounds);

      return {
        general,
        lol,
        maxRounds,
      };
    }),

  getCombinedRatingTable: (selector, maxRounds = 6) => Api
    .getRating(selector)
    .then(([generalRating, lolRating]) => {
      const combinedRating = combineRatings(generalRating, lolRating, maxRounds);

      return {
        general: combinedRating,
        lol: [],
        maxRounds,
      };
    }),
};
